import React from "react";
import { JcCommonProps, JcUtils } from "../../utils/JcUtils";
import { JcRow } from "../JcBox";

export interface JcAppTitleBarProps extends JcCommonProps {
    readonly topLeft?: React.ReactNode;
    readonly title?: React.ReactNode;
    readonly topRight?: React.ReactNode;
    readonly noBorderBottom?: boolean;
}

export const JcAppTitleBar = (props: JcAppTitleBarProps): React.ReactElement => {
    const commonProps = JcUtils.commonProps(props, [
        "jc-app-title-bar",
        props.noBorderBottom && "jc-app-title-bar-no-border",
    ]);
    return <header {...commonProps}>
        <JcRow alignCenter className="jc-app-title-bar-top-left">{props.topLeft}</JcRow>
        <JcRow alignCenter className="jc-app-title-bar-title">{props.title}</JcRow>
        <JcRow alignCenter className="jc-app-title-bar-top-right">{props.topRight}</JcRow>
    </header>;
};
